import React, { useMemo } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface SalesFunnelData {
    qualifiedCalls: number;
    transferCompleted: number;
    consultBooked: number;
    callsAbandoned: number;
    totalCount: number;
}

interface SalesFunnelAreaProps {
    data: SalesFunnelData;
    title?: string;
    height?: number;
}

interface ChartDataPoint {
    name: string;
    value: number;
}

const SalesFunnelArea = ({
    data,
    title = 'Sales Funnel',
    height = 300,
}: SalesFunnelAreaProps): React.JSX.Element | null => {
    const chartData = useMemo((): ChartDataPoint[] => {
        const { qualifiedCalls, transferCompleted, consultBooked, callsAbandoned, totalCount } = data;

        return [
            { name: 'Contacted', value: callsAbandoned },
            { name: 'Qualified', value: qualifiedCalls },
            { name: 'Transferred', value: transferCompleted },
            { name: 'Sales', value: consultBooked },
        ];
    }, [data]);

    if (!data || chartData.length === 0) {
        return null;
    }

    return (
        <div style={{ width: '100%', height: height }}>
            <h4 style={{ textAlign: 'center', marginBottom: '15px' }}>{title}</h4>
            <ResponsiveContainer width='100%' height='80%'>
                <AreaChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                    <CartesianGrid strokeDasharray='3 3' />
                    <XAxis dataKey='name' />
                    <YAxis />
                    <Tooltip />
                    <Area type='monotone' dataKey='value' stroke='#8884d8' fill='#8884d8' fillOpacity={0.6} />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    );
};

export default SalesFunnelArea;
